<template>
	<div id="app">
		<menubar class="d-print-none"></menubar>
		<div class="container-lesmo">
			<div class="d-flex">
				<div class="side-menu d-print-none" v-if="hasMenuBar">
					<menuleft></menuleft>
				</div>
				<div class="p-2 main-content">
					<router-view />
				</div>
			</div>
		</div>
		<footer class="d-print-none">
			<div class="footer">Craft by Anonymous Traveler Studio</div>
		</footer>
	</div>
</template>

<script>
import Menubar from "@/widgets/Menubar.vue";
import Menuleft from "@/widgets/Menuleft.vue";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	name: "App",
	components: {
		Menubar,
		Menuleft,
	},
	computed: {
		...mapState(["mainMenuActiveIndex", "hasMenuBar", "isLogin"]),
	},
	methods: {
		...mapMutations(["checkPrivilege", "getStores"]),
	},
	watch: {
		isLogin: {
			handler(val) {
				if (val) {
					this.checkPrivilege();
				}
			},
			immediate: true,
		},
	},
	mounted() {
		this.getStores(true);
	},
};
</script>
<style>
html,
body {
	width: 100%;
}
.container-lesmo {
	width: 100%;
	min-height: 100vh;
}

.main-content {
	min-height: 100vh;
	position: relative;
	flex-grow: 3;
}
.side-menu {
	width: 10rem;
}

.side-menu.ziped {
	width: 2rem;
}
#app {
	width: 100%;
	min-height: 100vh;
}
</style>
